import { render, staticRenderFns } from "./FinalQuizzItem.vue?vue&type=template&id=15e50560&scoped=true&"
import script from "./FinalQuizzItem.vue?vue&type=script&lang=js&"
export * from "./FinalQuizzItem.vue?vue&type=script&lang=js&"
import style0 from "./FinalQuizzItem.vue?vue&type=style&index=0&id=15e50560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e50560",
  null
  
)

export default component.exports